import React from "react";
import {
  Box,
  Button,
  TextField,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useMutation ,useQuery } from "@apollo/client";
import swal from "sweetalert";
import Header from "../../../../components/Header";
import {ALL_TITLES,
  CREATE_TITLE,
  UPDATE_TITLE,
} from "../../../../data/SetupManagementData"; 

const TitleForm = (props) => {
  
  const {
    loading,
    error,
  } = useQuery(ALL_TITLES);

  const [createTitle] = useMutation(CREATE_TITLE, {
    onCompleted: (data) => {
      props.onClose()
      if (props.onAction) {
        props.onAction();
      }
      else {
        props.refetch()
      }
      swal("Success!", "Title has been created successfully", "success");
    },
    onError: () => {
      swal("Error!", "Unable to create title, try again later", "error");
    },
  });

  const [updateTitle] = useMutation(UPDATE_TITLE, {
    onCompleted: () => {
      props.onClose()
      if (props.onAction) {
        props.onAction();
      }
      else {
        props.refetch()
      }
      swal("Success!", "Title has been updated successfully", "success");
    },
    onError: () => {
      swal("Error!", "Unable to update title, try again later", "error");
    },
  });

  const initialValues = {
    title: props.titleData ? props.titleData.title : "",
  };

  const validationSchema = yup.object().shape({
    title: yup.string().required("Title is required"),
  });
  
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { title } = values;
  
      if (props.isEditing) {
        await updateTitle({
          variables: {
            id: props.titleData.id,
            title,
          },
        });
        console.log("Title updated successfully!");
      } else {
        await createTitle({
          variables: {
            title,
          },
        });
        console.log("Title created successfully!");
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  
    setSubmitting(false);
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Title" : "Create Title"}
        subtitle={
          props.isEditing ? "Edit an Existing Title" : "Create a New Title"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Title *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.title}
                name="title"
                error={touched.title && !!errors.title}
                helperText={touched.title && errors.title}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default TitleForm;
